import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from '@Common/widgets/flex-layout/flex-layout.module';
import {MatAngularModule} from '@Common/mat-angular.module';
import {GestionRoutingModule} from './gestion-routing';
import {CommonModuleP8} from '@Common/common-p8.module';
import {AccueilGestionComponent} from './accueil/accueil-gestion.component';
import { VersementsComponent } from './versements/versements.component';
import {CommonArchivageModule} from 'app/archivage/common/common.module';
import { ListeBelComponent } from './eliminations/liste-bel/liste-bel.component';
import { BelEditComponent } from './eliminations/bel-edit/bel-edit.component';
import {ReactiveFormsModule} from '@angular/forms';
import { DocumentsComponent } from './eliminations/documents/documents.component';
import { BelViewComponent } from './eliminations/bel-view/bel-view.component';
import { InformationsComplementairesComponent } from './eliminations/informations-complementaires/informations-complementaires.component';
import { InformationComplementaireFieldComponent } from './eliminations/informations-complementaires/information-complementaire-field/information-complementaire-field.component';
import {ListLoaningsComponent} from './consultation/list-loanings/list-loanings.component';
import {LoaningModule} from '../loaning/loaning.module';

@NgModule({
    declarations: [
        AccueilGestionComponent,
        VersementsComponent,
        ListeBelComponent,
        BelEditComponent,
        DocumentsComponent,
        BelViewComponent,
        InformationsComplementairesComponent,
        InformationComplementaireFieldComponent,
        ListLoaningsComponent,
    ],
  imports: [
    FlexLayoutModule,
    MatAngularModule,
    CommonModule,
    GestionRoutingModule,
    CommonModuleP8,
    CommonArchivageModule,
    ReactiveFormsModule,
    LoaningModule,
  ],
    exports: [],
})
export class GestionModule {
}
